// Зеркало App\Enums\RoleCode. Права (кто кем управляет) приходят с бэкенда в user.abilities.
export const ROLE = Object.freeze({
    ADMIN: 'admin',
    AGENCY: 'agency',
    USER_PRO: 'user_pro',
    USER_STANDARD: 'user_standard',
});

export const ROLE_FAMILY = Object.freeze({
    ADMIN: 'admin',
    AGENCY: 'agency',
    CLIENT: 'client',
});

export const CLIENT_ROLES = Object.freeze([ROLE.USER_PRO, ROLE.USER_STANDARD]);

export const ROLE_FAMILY_HINT = Object.freeze({
    [ROLE_FAMILY.ADMIN]: 'Видит все данные и управляет всеми пользователями.',
    [ROLE_FAMILY.AGENCY]: 'Работает с выбранными партнёрами и заводит своих клиентов.',
    [ROLE_FAMILY.CLIENT]: 'Видит только выбранных рекламодателей, их бренды и кампании.',
});

/** Какие семейства ролей может держать в своём дереве владелец (зеркало RoleCode::ownableRoles). */
const OWNABLE_FAMILIES = Object.freeze({
    [ROLE_FAMILY.ADMIN]: [ROLE_FAMILY.ADMIN, ROLE_FAMILY.AGENCY, ROLE_FAMILY.CLIENT],
    [ROLE_FAMILY.AGENCY]: [ROLE_FAMILY.CLIENT],
    [ROLE_FAMILY.CLIENT]: [],
});

export const ROLE_FILTER_OPTIONS = Object.freeze([
    { code: ROLE.ADMIN, label: 'Администратор' },
    { code: ROLE.AGENCY, label: 'Агентство' },
    { code: ROLE.USER_PRO, label: 'User PRO' },
    { code: ROLE.USER_STANDARD, label: 'User Standard' },
]);

export const roleLabel = code => ROLE_FILTER_OPTIONS.find(option => option.code === code)?.label || code || '—';

export const isClientRole = (code) => CLIENT_ROLES.includes(code);

export const roleFamily = (code) => {
    if (code === ROLE.ADMIN) return ROLE_FAMILY.ADMIN;
    if (code === ROLE.AGENCY) return ROLE_FAMILY.AGENCY;
    if (isClientRole(code)) return ROLE_FAMILY.CLIENT;
    return null;
};

export const canFamilyOwn = (ownerFamily, childFamily) => (OWNABLE_FAMILIES[ownerFamily] || []).includes(childFamily);
